var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 19.6L17.6 14.8C18.5 13.4 19 11.8 19 10C19 5 15 1 10 1C5 1 1 5 1 10C1 15 5 19 10 19C11.8 19 13.4 18.5 14.8 17.6L19.6 22.4C20 22.8 20.5 23 21 23C22.1 23 23 22.1 23 21C23 20.4 22.8 19.9 22.4 19.6ZM5 10C5 7.2 7.2 5 10 5C12.8 5 15 7.2 15 10C15 12.8 12.8 15 10 15C7.2 15 5 12.8 5 10Z",
    fill: "#05164D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.08d2e557a8a284d07f0c11a05156a88a.svg";
export { ForwardRef as ReactComponent };